module.exports = __webpack_public_path__ + "static/media/allUsers.5d423238.svg";